import React from 'react';
import { Icon, IconName } from '@dapp/multi-lib/sdaoui/Icon';
import { cx } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

type MenuItemIconProps = {
  icon: IconName;
  className?: string;
  active?: boolean;
};
export const MenuItemIcon = (props: MenuItemIconProps) => {
  const { icon, className = '', active } = props;
  const bgClass = active ? 'bg-[#EDFF6D]' : 'bg-[#1B1D1E]';
  const iconName = active ? (`${icon}_dark` as IconName) : icon;

  return (
    <div className={twMerge(cx('rounded-full p-2', bgClass), className)}>
      <Icon icon={iconName} height={24} width={24} color='white' />
    </div>
  );
};
